import {pingBackend} from "@services/helpers/sessionHandler";

// local state
const getDefaultState = () => {
  return {
    svgs: [],
    controllingSvgs: [],
  }
};

const getters = {};

const mutations = {
  updateSvgs(state, svgs) {
    state.svgs = svgs;
  },
  updateControllingSvgs(state, svgs) {
    state.svgs = svgs;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const state = getDefaultState();

const actions = {
  resetState({commit}) {
    commit("resetState");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
